import { useCallback, useState } from "react"

/**
 * Envuelve una función de la capa service y expone su estado completo.
 *
 * Devuelve { data, error, loading, fetch, empty }:
 *  - data:    null hasta que hay respuesta OK. Nunca guarda un error.
 *  - error:   el ApiError si la última llamada falló, null si salió bien.
 *  - loading: true mientras la request está en vuelo.
 *  - fetch:   ejecuta la llamada. Devuelve la data, o null si falló.
 *             No relanza el error: ya queda observable en `error`.
 *  - empty:   limpia data y error.
 */
export function useApiLeiten({ apiService }) {
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const fetch = useCallback(async (conditionData = '') => {
        setLoading(true)
        setError(null)
        try {
            const response = await apiService(conditionData)
            const value = response?.data ?? response
            setData(value)
            return value
        }
        catch (err) {
            console.error('Error en la API:', err)
            setError(err)
            setData(null)
            return null
        }
        finally {
            setLoading(false)
        }
    }, [apiService])

    const empty = useCallback(() => {
        setData(null)
        setError(null)
    }, [])

    return { data, error, loading, fetch, empty }
}
